import { render, staticRenderFns } from "./sideList.vue?vue&type=template&id=49f86eb5&scoped=true&"
import script from "./sideList.vue?vue&type=script&lang=js&"
export * from "./sideList.vue?vue&type=script&lang=js&"
import style0 from "./sideList.vue?vue&type=style&index=0&id=49f86eb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f86eb5",
  null
  
)

export default component.exports